<script lang="ts" setup>
import ScheduleItemForm from '@/components/content/ScheduleItemForm.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { ScheduleItem } from '@/models/schedule-item.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { format, parse } from 'date-fns';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();
const events = useEvents();

const scheduleItems = computed<ScheduleItem[]>(
  () => store.state.cns.scheduleItems,
);

const update = () => {
  store.dispatch(ContentStoreActions.GetSchedules);
};

onMounted(() => {
  events.on(Event.UpdateContentItem, update);
  events.on(Event.LanguageChanged, update);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.UpdateContentItem, update);
  events.off(Event.LanguageChanged, update);
});

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Date', key: 'date', width: '15%' },
  { title: 'Description', key: 'description', width: '30%' },
  { title: 'Initiative', key: 'initiative', width: '25%' },
];

const editItem = (_: MouseEvent, rowData: { item: ScheduleItem }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(ScheduleItemForm),
    data: rowData.item,
  });
};

const addItem = () => {
  const item: ScheduleItem = {
    id: -1,
    description: '',
    date: format(new Date(), 'dd-MM-yyyy'),
    initiative: null,
  };

  store.commit(Mutations.ShowDrawer, {
    component: markRaw(ScheduleItemForm),
    data: item,
  });
};
</script>
<template>
  <v-container>
    <h2>Scheduled Initiatives <CurrentLanguage /></h2>

    <v-data-table
      density="compact"
      :headers="headers"
      :items="scheduleItems"
      @click:row.prevent="editItem"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.date="{ item }">
        {{ format(parse(item.date, 'dd-MM-yyyy', new Date()), 'MMMM do yyyy') }}
      </template>
      <template v-slot:item.initiative="{ item }">
        {{ item.initiative!.title }}
      </template>
    </v-data-table>

    <v-btn color="success" @click="() => addItem()">Add Schedule</v-btn>
  </v-container>
</template>
